const faqs = [
  {
    question: "How long does a typical detail take?",
    answer: "Depending on the package and condition of your vehicle, most detailing services take between 2-5 hours. Our basic ECO Wash takes about 1-2 hours, while a Complete Detail can take 4-6 hours for optimal results."
  },
  {
    question: "Do I need to prepare my car before you arrive?",
    answer: "We recommend removing personal items and valuables from your vehicle, but other than that, no preparation is necessary. We'll take care of everything else!"
  },
  {
    question: "What areas do you serve?",
    answer: 'We serve the entire Twin Cities metro area including Minneapolis, St. Paul, and all surrounding suburbs. Check our <a href="#locations" class="text-primary hover:underline">service areas</a> for more details.'
  },
  {
    question: "Do you provide ceramic coating services?",
    answer: "Yes! We offer professional ceramic coating services that provide 3-5 years of protection for your vehicle's paint. Our ceramic coating service includes proper paint preparation to ensure the best results."
  },
  {
    question: "What forms of payment do you accept?",
    answer: "We accept all major credit cards, cash, and electronic payments including Apple Pay, Google Pay, and Venmo for your convenience."
  }
];

const FAQSection = () => (
  <section id="resources" className="py-16 bg-primary-dark text-white">
    <div className="container mx-auto px-4">
      <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
        Resources
      </h2>
      <div id="faq" className="mb-16">
        <h3 className="text-2xl font-bold mb-8 text-center text-white">Frequently Asked Questions</h3>
        <div className="max-w-3xl mx-auto divide-y divide-gray-200 divide-opacity-30">
          {faqs.map((faq, i) => (
            <div className="py-6" key={i}>
              <h4 className="text-lg font-semibold text-white mb-2">{faq.question}</h4>
              <p className="text-white" dangerouslySetInnerHTML={{ __html: faq.answer }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default FAQSection; 